import React from "react";
import Tooltip from "@mui/material/Tooltip";

export interface IProps {
  /**
   * クリックした場合のCalllback
   */
  onClick?: () => void;
  /**
   * アイコン
   */
  icon: JSX.Element;
  /**
   * ツールチップ
   */
  tooltip?: string | JSX.Element;
  /**
   * cssスタイル
   */
  style?: React.CSSProperties;
}

class ToolMenuIconButton extends React.Component<IProps> {
  render(): JSX.Element {
    const iconButton = (
      <button
        style={
          this.props.style
            ? this.props.style
            : { margin: "5px", width: "40px", height: "40px" }
        }
        onClick={this.props.onClick}
      >
        {this.props.icon}
      </button>
    );
    const button = this.props.tooltip ? (
      <Tooltip title={this.props.tooltip}>{iconButton}</Tooltip>
    ) : (
      iconButton
    );
    return <React.Fragment>{button}</React.Fragment>;
  }
}

/**
 * ツールメニューアイコンボタン
 */
export default ToolMenuIconButton;
